"use client";

import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import FormCard from "../../components/FormCard";
import { formFieldsSign } from "../../components/FormCard/formFields";
import { mapGender } from "../../constants";
import { AstroUserData } from "../../Enum";
import styles from "./zodiac-comp.module.scss";

const ZodiacCompatibility = () => {
  const router = useRouter();
  const [submit, setSubmit] = useState(false);
  const [zodiac, setZodiac] = useState("");
  const [partnerZodiac, setPartnerZodiac] = useState("");

  const getFormData = (formName: string, data: AstroUserData | null) => {
    if (!data) {
      setSubmit(false);
      return;
    }

    if (formName === "maleData") {
      setZodiac(data?.zodiac as string);
    }
    if (formName === "femaleData") {
      setPartnerZodiac(data?.zodiac as string);
    }
  };

  const handleSubmit = () => {
    setSubmit(true);
    setTimeout(() => setSubmit(false), 500);
  };

  useEffect(() => {
    if (zodiac && partnerZodiac) {
      router.push(`/compatibility/zodiac/${zodiac}/${partnerZodiac}`);
    }
  }, [zodiac, partnerZodiac]);

  return (
    <div>
      <div className={styles.zodiacWrapper}>
        <form className={styles.formWrapper}>
          <FormCard
            initialData={{}}
            submit={submit}
            formFields={formFieldsSign}
            gender="Male"
            onSubmit={getFormData}
            title="Your Zodiac"
          />
        </form>
        <form className={styles.formWrapper}>
          <FormCard
            initialData={{}}
            submit={submit}
            formFields={formFieldsSign}
            gender="Female"
            onSubmit={getFormData}
            title="Partner Zodiac"
          />
        </form>
      </div>
      <div className={styles.buttonWrapper}>
        <button onClick={handleSubmit}>Submit</button>
      </div>
    </div>
  );
};

export default ZodiacCompatibility;
